const getState = (state) => state.icf;
export const getIcfState = (state) => getState(state);
export const getGlobalItemLists = (state) => getState(state).globalItemLists;
//# sourceMappingURL=selectors.js.map